import QRCode from "react-qr-code";
import styled from "styled-components";
import CommonModal from "../based/Modal";

function QRModal({ show, onClose, qrString }) {
    return (
        <CommonModal show={show} onClose={onClose}>
            <Wrapper>
                <div className="qr-code">
                    <QRCode id="qr-code" value={qrString} size={120} />
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default QRModal;

const Wrapper = styled.div``;
